import React from 'react';

const currentYear = new Date().getFullYear();

const Footer = () => (
  <div className="footer">
    <h2>Nemwel Boniface</h2>

    <div className="footerIcons">
      <ul>
        <li>
          <a href="https://www.linkedin.com/in/nemwel-nyandoro" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
            <i className="fa fa-linkedin" aria-hidden="true" />
          </a>
        </li>
        <li>
          <a href="https://github.com/Nemwel-Boniface" aria-label="GitHub" target="_blank" rel="noopener noreferrer">
            <i className="fa fa-github" aria-hidden="true" />
          </a>
        </li>
        <li>
          <a href="https://angel.co/u/nemwel-nyandoro" aria-label="AngelList" target="_blank" rel="noopener noreferrer">
            <i className="fa fa-angellist" aria-hidden="true" />
          </a>
        </li>
        <li>
          <a href="https://twitter.com/nemwel_bonie" aria-label="Twitter" target="_blank" rel="noopener noreferrer">
            <i className="fa fa-twitter" aria-hidden="true" />
          </a>
        </li>
      </ul>
    </div>

    <p>
      Nemwel &copy;
      {' '}
      {currentYear}
      {' '}
      all rights reserved.
    </p>
  </div>
);

export default Footer;
